import validator from 'validator';

/**
 * Validates a postal code.
 * Checks against the UK (GB) format first, and falls back to a global validation check.
 * 
 * @param {string} postcode - The postal code to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const isValidPostalCode = (postcode) => {
  if (!postcode || typeof postcode !== 'string') {
    return false;
  }
  
  const trimmed = postcode.trim();
  if (trimmed === "") {
    return false;
  }

  // Validate as UK post code
  if (validator.isPostalCode(trimmed, 'GB')) {
    return true;
  }

  // Validate as generic global post code
  // 'any' locale checks against all known formats in the validator library
  if (validator.isPostalCode(trimmed, 'any')) {
    return true;
  }

  return false;
};
